import { sizeToSubtitleFontSize, sizeToTitleFontSize } from './utils';
import { LabelContainer, StyledTypography, IconContainer, Container } from './styled';
export function IconWithLabel(props) {
    const { title, subtitle, size = '2xl', className, alignment = 'horizontal', truncate = true, children } = props;
    return (<Container className={className} $alignment={alignment} $size={size}>
      <IconContainer $size={size}>{children}</IconContainer>
      <LabelContainer $size={size} $alignment={alignment}>
        {title && (<StyledTypography $truncate={truncate} $appearance="300" $fontSize={sizeToTitleFontSize[size]} $lineHeight="neutralized" $fontWeight="medium">
            {title}
          </StyledTypography>)}
        {subtitle && (<StyledTypography $truncate={truncate} $appearance="100" $fontSize={sizeToSubtitleFontSize[size]} $lineHeight="neutralized" $fontWeight="regular">
            {subtitle}
          </StyledTypography>)}
      </LabelContainer>
    </Container>);
}
